require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M44.96 12.887a5.221 5.221 0 0 0-3.683-3.684C38.027 8.332 25 8.332 25 8.332s-13.027 0-16.277.871a5.221 5.221 0 0 0-3.684 3.684C4.168 16.137 4.168 25 4.168 25s0 8.863.871 12.113a5.221 5.221 0 0 0 3.684 3.684c3.25.871 16.277.871 16.277.871s13.027 0 16.277-.871a5.215 5.215 0 0 0 3.684-3.684c.871-3.25.871-12.113.871-12.113s0-8.863-.871-12.113zM20.833 30.414V19.586c0-.8.871-1.3 1.563-.902l9.375 5.414a1.041 1.041 0 0 1 0 1.804l-9.375 5.414a1.044 1.044 0 0 1-1.563-.902zm0 0"
  }));
};

exports["default"] = _default;